import store from "@app2/store";
import {set} from "@app2/utils/helpers";

export const isSubscriptionCancelled = () => {
    const activeSubscription = store.getters['auth/GET_SUBSCRIPTION'];
    return activeSubscription?.status === 'cancelled';
};

export const handleSubscription = async (to, from, next) => {
    if ( to.name === 'RegisterForm' && to.query.checkout && to.query.step === 'payment' ) {
        next();
        return;
    }
    if ( to.name === from.name && JSON.stringify(to.params) === JSON.stringify(from.params) && JSON.stringify(to.query) === JSON.stringify(from.query) ) {
        next(false);
        return;
    }
    const activeSubscription = store.getters['auth/GET_SUBSCRIPTION'];
    const user = store.getters['auth/GET_USER'];
    if (!activeSubscription && user?.meta?.trial_hash) {
        if ( !window.Searchie?.checkout ) {
            await store.dispatch('auth/fetchPlan', user.meta?.trial_hash);
            set(window, 'Searchie.checkout', store.getters['auth/GET_PLANS'].find(plan => plan.hash === user.meta?.trial_hash));
        }
        const coupon = user.meta?.checkout_coupon;
        const plan = window.Searchie?.checkout;

        // Only add step=payment if plan requires payment AND user doesn't have a payment method
        const planRequiresPayment = plan?.collect_payment_method || false;
        const hasPaymentMethod = !!user?.chargebee_primary_payment_source;
        const needsPayment = planRequiresPayment && !hasPaymentMethod;

        const targetQuery = {checkout: user.meta?.trial_hash, coupon};
        if (needsPayment) {
            targetQuery.step = "payment";
        }

        // Check if we're already going to RegisterForm with the correct query params
        if (to.name === 'RegisterForm' &&
            to.query.checkout === targetQuery.checkout &&
            to.query.step === targetQuery.step) {
            // Already going to the right place, allow it
            next();
            return;
        }

        // Redirect to RegisterForm with correct query params
        next({name: 'RegisterForm', query: targetQuery});
        return;
    }
    if (isSubscriptionCancelled() && !to.path.includes('/settings/')) {
        next({name: 'AccountSubscription'});
    } else {
        // User is subscribed, allow navigation to the target route
        next();
    }
};

export const subscribedGuard = async (to, from, next) => {
    const user = store.getters['auth/GET_USER'];
    if (!user) {
        next({name: 'Login'});
        return;
    }
    await handleSubscription(to, from, next);
};